import { usePunditUserContext } from "@circle-react/contexts";

export const useIsFilterBackendConfigurationEnabled = () => {
  const { currentCommunitySettings, isLoading } = usePunditUserContext();

  return !!(
    !isLoading && currentCommunitySettings?.filter_backend_configuration_enabled
  );
};
